import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=2ec411fc&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=2ec411fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec411fc",
  null
  
)

export default component.exports